/**
 * Implement Gatsby's Browser APIs
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import { detect } from 'detect-browser'

import store from './src/store'
import getUrlParam from './src/lib/getUrlParam'

import './src/css/tailwind.css'
import './src/scss/main.scss'

export const onClientEntry = () => {
  // grab refcode from url if it exists, to pass through to actblue links
  store.refcode = getUrlParam('refcode') || getUrlParam('trackingcode')
  store.refcode2 = getUrlParam('refcode2')
}

export const onRouteUpdate = ({ location }) => {
  store.refcode = getUrlParam('refcode') || getUrlParam('trackingcode') || store.refcode
  store.refcode2 = getUrlParam('refcode2') || store.refcode2

  // persist refcode in url
  if (store.refcode) {
    if (location.search) {
      if (
        location.search.indexOf('refcode') === -1 &&
        location.search.indexOf('trackingcode') === -1
      ) {
        window.history.replaceState(
          {},
          '',
          `${location.pathname}${location.search}&refcode=${store.refcode}`
        )
      }
    } else {
      window.history.replaceState({}, '', `${location.pathname}?refcode=${store.refcode}`)
    }
  }
}
